
import { defineComponent, ref, onMounted, computed } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { Kamoku, KoteishisanType } from '@/repositories/fuzoku-meisai/data'
import { junsokuRepositories } from '@/repositories/fuzoku-meisai/junsoku/junsokuRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { KoteishisanUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import KoteishisanSettingItem from '@/views/fuzoku-meisai/junsoku/KoteishisanSettingItem.vue'
import JunsokuSettingTitle from '@/views/fuzoku-meisai/junsoku/JunsokuSettingTitle.vue'

const repository = junsokuRepositories.koteishisan

export default defineComponent({
  components: {
    JunsokuSettingTitle,
    KoteishisanSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    let kamokuSource: Kamoku[] = []
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)

    const mukeiItems = ref<KoteishisanUiItem[]>([])
    const yukeiItems = ref<KoteishisanUiItem[]>([])
    const otherItems = ref<KoteishisanUiItem[]>([])

    const isAllValid = computed(() => {
      const allCount = mukeiItems.value.length + yukeiItems.value.length + otherItems.value.length
      if (allCount === 0) {
        return true
      }
      const allValidCount = mukeiItems.value.filter(i => i.isValid).length +
        yukeiItems.value.filter(i => i.isValid).length +
        otherItems.value.filter(i => i.isValid).length
      return allCount === allValidCount
    })

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        await refreshUiData()
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        let params = yukeiItems.value.map(v => v.item)
        params = params.concat(mukeiItems.value.map(v => v.item))
        params = params.concat(otherItems.value.map(v => v.item))
        await repository.save(params)
        await refreshUiData()
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const addItem = (type: KoteishisanType) => {
      const targets = getUiItems(type)
      const newId = UiItemsLogic.makeId(targets)
      targets.push({
        isValid: false,
        item: {
          id: newId,
          itemName: '',
          type: type,
          summary: '',
          normalSetting: {
            sources: [...kamokuSource],
            targets: []
          },
          ruikeiSetting: {
            sources: [...kamokuSource],
            targets: []
          },
          shoukyakuhiSetting: {
            sources: [...kamokuSource],
            targets: []
          }
        }
      })
    }

    const upItem = (type: KoteishisanType, item: KoteishisanUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.upUiItem(items, item)
    }

    const downItem = (type: KoteishisanType, item: KoteishisanUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.downUiItem(items, item)
    }

    const trashItem = (type: KoteishisanType, item: KoteishisanUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.removeUiItem(items, item)
    }

    const onChangeInput = (type: KoteishisanType, item: KoteishisanUiItem) => {
      const items = getUiItems(type)
      UiItemsLogic.updateUiItem(items, item)
    }

    const getUiItems = (type: KoteishisanType) => {
      switch (type) {
        case 'Yukei':
          return yukeiItems.value
        case 'Mukei':
          return mukeiItems.value
        case 'Other':
          return otherItems.value
        default:
          throw Error('unknown type')
      }
    }

    const refreshUiData = async () => {
      const data = await repository.list()
      kamokuSource = data.kamokuSources
      yukeiItems.value = data.items.filter(v => v.type === 'Yukei').map(value => ({ item: value, isValid: true }))
      mukeiItems.value = data.items.filter(v => v.type === 'Mukei').map(value => ({ item: value, isValid: true }))
      otherItems.value = data.items.filter(v => v.type === 'Other').map(value => ({ item: value, isValid: true }))
    }

    return {
      loading,
      isAllValid,
      isSucceedRequest,
      requestError,
      mukeiItems,
      yukeiItems,
      otherItems,
      onClickRegister,
      onDismissAlert,
      addItem,
      upItem,
      downItem,
      trashItem,
      onChangeInput
    }
  }
})
